import React from "react";
import Banner from "../../components/banner/Banner";
import FarmerServices from "./FarmerServices";
import Title from "../../components/titles/Title";
import FarmerBenefits from "./FarmerBenefits";
import "./Farmer.css";
import CategoryProducts from "../../components/CategoryProducts/CategoryProducts";
import FPN from "../../assets/images/technology-icons/fpn.svg"

const Farmer = () => {
  return (
    <>
      <Banner
        className="farmer-bg"
        bannerTitle={[
          <span key="1">Access Pollination services to improve </span>,
          <br key="2" className="d-lg-block d-none"></br>,
          <span key="3"> crop yield & soil fertility</span>
        ]}
      />

      <CategoryProducts
        categoryId={["AGR12-100A"]}
        title="Pollination Services"
        description="Services not found"
        btn1text="Request Now"
      />

      <div className="section-sub-container text-center">
        <Title classname="mb-0" heading="Features" />
      </div>
      <FarmerServices />

      <div className="section-container benefit-container">
        <div className="container">
          <Title classname="text-center mb-5" heading="Benefits" />
          <FarmerBenefits />
        </div>
      </div>

      {/* <div className="section-container benefit-container">
        <div className="container">
            <Title classname="text-center mb-4" heading="USP" />
           <FarmerUSP/>
          </div>
      </div> */}
      {/* </div> */}



      <div className="section-container benefit-container">
        <div className="container">
          <div className="section-sub-container text-center">
            <Title classname="text-center mb-4" heading="Our Technology" />
            <img className="technoloy-icons d-block mb-2 mx-auto mt-4" src={FPN} alt="Field Production Network"/>
            <h5 className="mb-3">Field Production Network (FPN)</h5>

            {/* <p>
            Field Production Network (FPN) is an advanced technology solution provided by Apischain to support farmers in optimizing their field operations and improving agricultural productivity. The FPN leverages cutting-edge digital tools, real-time data, and analytics to help farmers manage their crops, monitor field conditions, and enhance yields.
            </p>
            <p>
              Agent, AgriMiner, Labour Farmer, Operator, Developer QA, Executive,
              Production Manager, FF
            </p> */}

            <p>
            Field Production Network (FPN) is an advanced technology solution provided by Apischain to support farmers in optimizing their field operations and improving agricultural productivity. The FPN leverages cutting-edge digital tools, real-time data, and analytics to help farmers manage their crops, monitor field conditions, and enhance yields.
            </p>
            <p>
              Agent, AgriMiner, Labour Farmer, Operator, Developer QA, Executive,
              Production Manager, FF
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Farmer;
